import { columns } from "../../../dtos/columns";
import inmobiliariaDto from "../../maestros/inmobiliarias/models/inmobiliariaDto";
import CustomTooltip from "../../../components/ui/customToolTip";
import { format } from "rut.js";
import { Cobertura } from "../models/seguroDeudor";
import { numericFormatter } from "react-number-format";

export function useColumnsCoberturas(montoAsegurado: number) {

    const COLUMNS: columns<Cobertura>[] = [
        {
            name: 'Código cobertura',
            selector: (row) => row.codigoCobertura,
            sortable: true,
            sortField: 'codigoCobertura',
            wrap: true,
            export: false,
            center: false,
        },
        {
            name: 'Tasa',
            selector: (row) => numericFormatter(row.tasa.toString(), { "thousandsGroupStyle": "thousand", "thousandSeparator": ".", "decimalSeparator": ",", "suffix": "%" }),
            sortable: true,
            sortField: 'tasa',
            wrap: true,
            export: false,
            center: true,
        },
        {
            name: 'Prima',
            selector: (row) => numericFormatter((montoAsegurado * (row.tasa / 1000)).toFixed(4).toString(), { "thousandsGroupStyle": "thousand", "thousandSeparator": ".", "decimalSeparator": ",", "prefix": "UF " }),
            sortable: true,
            sortField: 'prima',
            wrap: true,
            export: false,
            center: true,
        }
    ];

    return { COLUMNS };
}